import { render, staticRenderFns } from "./ScenarioEditDialogsInstitutions.vue?vue&type=template&id=21ba8d06"
import script from "./ScenarioEditDialogsInstitutions.vue?vue&type=script&lang=js"
export * from "./ScenarioEditDialogsInstitutions.vue?vue&type=script&lang=js"
import style0 from "./ScenarioEditDialogsInstitutions.vue?vue&type=style&index=0&id=21ba8d06&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports